'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.event_report', {
    template: '<event-report></event-report>'
  });
}



// WEBPACK FOOTER //
// ./public/dev/app/event_report/event_report.routes.js